import React, { useEffect, useState } from "react"
import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import arrow from '../../Assests/left-arrow.png'
import quote from '../../Assests/quote.png'
import './ProductInfo.css'
import { useNavigate } from "react-router-dom"
import { urlApiServerImage } from "../../Config/Config"

function ProductInfo(props) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const navigate = useNavigate(); // Correct hook usage

    const renderFormattedArticleText = (text) => {
        if (!text) return null;

        // Dividir por líneas
        const lines = text.split('\n');

        return lines.map((line, lineIndex) => {
            // Procesar encabezados Markdown
            const headerMatch = line.match(/^(#{1,4})\s(.*)$/);
            if (headerMatch) {
                const [, hashes, content] = headerMatch;
                const level = hashes.length;
                const HeadingTag = `h${level}`;

                return React.createElement(
                    HeadingTag,
                    {
                        key: lineIndex,
                        className: "productHeading"
                    },
                    content
                );
            }

            // Procesar imágenes Markdown ![alt text](url)
            const imageMatch = line.match(/!\[(.*?)\]\((https?:\/\/[^\s]+)\)/);
            if (imageMatch) {
                const [, , imageUrl] = imageMatch;

                return (
                    <div key={lineIndex} className="photoContainerArticle">
                        <img
                            src={imageUrl}
                            alt=""
                            className="contentImageArticle"
                        />
                    </div>
                );
            }

            // Procesar citas (líneas que comienzan con >)
            if (line.trim().startsWith('>')) {
                return (
                    <div key={lineIndex} className="quote-container">
                        <img src={quote} alt="quote" className="quote-image" />
                        <span className="quote-text">
                            {line.substring(1).trim()}
                        </span>
                    </div>
                );
            }

            // Función para procesar negritas (**texto**) y enlaces ([texto](url))
            const processBoldAndLinks = (text) => {
                const parts = [];
                let lastIndex = 0;
                let currentText = text;

                // Procesar negritas
                const boldRegex = /\*\*(.*?)\*\*/g;
                let boldMatch;

                while ((boldMatch = boldRegex.exec(currentText)) !== null) {
                    // Texto antes de la negrita
                    if (boldMatch.index > lastIndex) {
                        parts.push(currentText.substring(lastIndex, boldMatch.index));
                    }
                    // Texto en negrita
                    parts.push(<strong key={`bold-${boldMatch.index}`} className='boldText'>{boldMatch[1]}</strong>);
                    lastIndex = boldRegex.lastIndex;
                }

                // Texto restante después de la última negrita
                if (lastIndex < currentText.length) {
                    parts.push(currentText.substring(lastIndex));
                }

                // Procesar enlaces en el texto resultante
                const processedParts = [];
                lastIndex = 0;

                parts.forEach((part, partIndex) => {
                    if (typeof part === 'string') {
                        const linkRegex = /\[(.*?)\]\((.*?)\)/g;
                        let linkMatch;
                        let linkText = part;
                        let linkLastIndex = 0;

                        while ((linkMatch = linkRegex.exec(linkText)) !== null) {
                            // Texto antes del enlace
                            if (linkMatch.index > linkLastIndex) {
                                processedParts.push(linkText.substring(linkLastIndex, linkMatch.index));
                            }
                            // Enlace
                            processedParts.push(
                                <a
                                    key={`link-${partIndex}-${linkMatch.index}`}
                                    href={linkMatch[2]}
                                    className="article-link"
                                    style={{ textDecoration: 'none' }}
                                >
                                    {linkMatch[1]}
                                </a>
                            );
                            linkLastIndex = linkRegex.lastIndex;
                        }
                        // Texto restante
                        if (linkLastIndex < linkText.length) {
                            processedParts.push(linkText.substring(linkLastIndex));
                        }
                    } else {
                        processedParts.push(part);
                    }
                });

                return processedParts;
            };

            // Si es una línea vacía, añadir un salto de línea
            if (line.trim() === '' && lineIndex < lines.length - 1) {
                return <br key={lineIndex} />;
            }

            return (
                <p className="product-paragraph" key={lineIndex}>
                    {processBoldAndLinks(line)}
                    {lineIndex < lines.length - 1 && <br />}
                </p>
            );
        });
    };

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const productImages = props.product?.Imagenes || [];
    const hasImages = productImages.length > 0;

    const relatedProducts = props.products || [];


    function handleCloseArticle() {
        // Aquí necesitamos acceder a la función que cambia el estado en el componente padre
        // Como estamos pasando la prop 'onClose' desde Articles, la usamos así:
        if (props.onClose) {
            props.onClose();
        }
    }

    const handleProductClick = (selectProduct) => {
        // Correct navigation using the hook
        navigate('/Inicio', { state: { product: selectProduct } });
    };

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
    };

    return (
        <>
            <div>
                <div className="bannerContainer" style={{ backgroundImage: `url(${props.background})`, height: '42vh' }}>
                    <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                </div>
                <img src={arrow} alt="arrow" className="arrowBack" onClick={handleCloseArticle} />
                <div className="containerForAllProductInformation">
                    <div className="containerTitleAndImage">
                        <div className="imageProductInfo">
                            {hasImages ? (
                                <>
                                    <img
                                        src={urlApiServerImage + productImages[currentImageIndex].url}
                                        alt="Imagen principal"
                                        className="imageProduct"
                                    />
                                    {productImages.length > 1 && (
                                        <div className="additionalImagesSection">
                                            <p className="additionalImagesTitle">Más imágenes del producto:</p>
                                            <div className="additionalImagesContainer">
                                                {productImages
                                                    .filter((_, index) => index !== currentImageIndex)
                                                    .map((image, index) => {
                                                        const originalIndex = productImages.findIndex(img => img.id === image.id);
                                                        return (
                                                            <img
                                                                key={image.id}
                                                                src={urlApiServerImage + image.url}
                                                                alt={`Vista adicional ${originalIndex + 1}`}
                                                                className="additionalImage"
                                                                onClick={() => handleThumbnailClick(originalIndex)}
                                                            />
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="noImagePlaceholder">No hay imágenes disponibles</div>
                            )}
                        </div>
                        <div className="titleProductInfoContainer">
                            <div className="titleProductInfo">
                                <p className="nameProduct">{props.product?.Nombre || 'Nombre no disponible'}</p>
                            </div>
                            <div className="categoryProductInfo">
                                <p className="categoryNameProduct">
                                    Categoria: {props.product?.categorias?.[0]?.Nombre || 'Categoría no disponible'}
                                </p>
                            </div>
                            <div className="priceProductInfo">
                                {props.product?.Mostrar_Precio && <p className="productPrice">Desde: $ {props.product?.precio || '0'} USD</p>}
                            </div>
                            <p className="productPrice">ID: {props.product?.id}</p>
                            <div className="descriptionProductInfo">
                                <div className="descriptionProduct">
                                    {renderFormattedArticleText(props.product?.descripcion)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className="titleLastProductsInProduct">Últimos productos</p>
            <div className="ProductinProductContainer">
                <div className="productGrid">
                    {relatedProducts.slice(0, 4).map(item => {
                        const itemImages = item?.Imagenes || [];
                        const hasItemImages = itemImages.length > 0;

                        return (
                            <div key={item.id} className="productCard" onClick={() => handleProductClick(item)}>
                                {hasItemImages ? (
                                    <img
                                        src={urlApiServerImage + itemImages[0].url}
                                        alt={item.Nombre}
                                        className="productImage"
                                    />
                                ) : (
                                    <div className="noImagePlaceholder">No hay imagen</div>
                                )}
                                <p className="productTitle">{item?.Nombre || 'Nombre no disponible'}</p>
                                <p className="productID">ID {item.id}</p>
                                {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}

export default ProductInfo;